<template>
  <span style="display: none" />
</template>

<script>
import activityTracker from '../../utils/activityTracker'

// Tu dong dang xuat khi khong thao tac qua so phut da cau hinh (mac dinh
// 10 phut, chinh duoc trong trang Quan tri > SettingsSecurity.vue). Day la
// LOP PHIA TRINH DUYET - chuyen ve man hinh dang nhap ngay khi het gio, KHONG
// can doi request ke tiep moi phat hien. Lop chan THAT (khong the lach qua
// gui thang API) nam o backend/Services/Auth/Adapters/JsonFile.php::user().
export default {
  name: 'IdleLogout',
  data() {
    return {
      henGio: null,
      daDangXuatDoRanh: false,
    }
  },
  mounted() {
    this.henGio = setInterval(this.kiemTraRanh, 15000)
    window.addEventListener('mousemove', this.ghiNhanHoatDong)
    window.addEventListener('keydown', this.ghiNhanHoatDong)
    window.addEventListener('click', this.ghiNhanHoatDong)
    window.addEventListener('touchstart', this.ghiNhanHoatDong)
  },
  beforeDestroy() {
    clearInterval(this.henGio)
    window.removeEventListener('mousemove', this.ghiNhanHoatDong)
    window.removeEventListener('keydown', this.ghiNhanHoatDong)
    window.removeEventListener('click', this.ghiNhanHoatDong)
    window.removeEventListener('touchstart', this.ghiNhanHoatDong)
  },
  methods: {
    ghiNhanHoatDong() {
      activityTracker.touch()
      this.daDangXuatDoRanh = false
    },
    kiemTraRanh() {
      if (this.is('guest') || this.daDangXuatDoRanh) {
        return
      }
      const phutKhongThaoTac = this.$store.state.config.idle_logout_minutes
      if (!phutKhongThaoTac) {
        return
      }
      const soPhutDaQua = (Date.now() - activityTracker.lastActivityAt) / 60000
      if (soPhutDaQua >= phutKhongThaoTac) {
        this.daDangXuatDoRanh = true
        this.forceLogout().then(() => {
          this.$toast.open({
            message: this.lang('Idle logout message'),
            type: 'is-warning',
            duration: 6000,
          })
        })
      }
    },
  },
}
</script>
